<template>
  <TitleCard :title="titleCard" :showMore="showMore">
    <div class="backStack-table-wrap">
      <div class="head-top-wrap">
        <div class="form-table-wrap">
          <Form
            ref="form"
            layoutType="grid"
            :optionList="formRow"
            :defaultModel="defaultValue"
          ></Form>
          <div class="operation-wrap">
            <a-button @click="clearAll">清空条件</a-button>
            <a-button @click="toSearch">搜索</a-button>
          </div>
        </div>
        <TableToolsWrap
          needLeft
          :btnList="utilsBtnList"
          @utilsClick="handlerActionClick"
        ></TableToolsWrap>
      </div>
      <Table
        ref="table"
        :options="fields"
        :tableValue="tableValue"
        :customSlotOpt="slotOpt"
        :otherOpt="customOtherOpt"
        @change="initTableValue"
        @actionClick="handlerActionClick"
      ></Table>
    </div>
    <AModal ref="modal" :customOpt="customModalOpt" @ok="handlerOk"></AModal>
  </TitleCard>
</template>

<script>
import Table from '../../components/table/index.vue'
import Form from '../../components/formTable/form.vue'
import AModal from '../../components/AModal'
import TableToolsWrap from '../../components/common/tableToolsWrap.vue'
// import makeFakerData from '@/mixins/makeFakerData'
import mixinsBackStack from '@/views/backstageSupport/mixins'
import { fields, slotOpt, formRow } from './configs/configs'
import {
  filterFinanceInfo,
  deleteFinanceInfo,
  issueFinanceInfo,
  downFinanceInfo
} from '@/api/serverInfo.js'

export default {
  mixins: [mixinsBackStack],
  data() {
    return {
      slotOpt,
      fields,
      formRow,
      tableValue: [],
      utilsBtnList: [
        { name: '新增', cb: 'addFinance' },
        { name: '发布', cb: 'batchIssue' },
        { name: '下架', cb: 'batchDown' },
        { name: '删除', cb: 'batchDelete' }
      ],
      customOtherOpt: {
        pagination: {
          pageSize: 10,
          pageNum: 1,
          total: 0
        }
      },
      params: {},
      defaultValue: {}
    }
  },
  components: {
    Table,
    Form,
    TableToolsWrap,
    AModal
  },
  mounted() {
    this.initSearchParams() // 重置搜索的参数
    this.initTableValue()
  },
  methods: {
    async initTableValue() {
      try {
        this.loadingTable(true)
        const params = this.dealSearchFormParams()
        const { rows, total } = await filterFinanceInfo(params)
        const row = this.handlerDateFormat(rows)
        this.handlerResultMappings(row) // 处理数据的映射关系
        this.tableValue = row
        this.customOtherOpt.pagination.total = total
        this.initSelectedRowIds() // 清空勾选的选项
      } catch (error) {
        this.$apiStatusHandler(99, '请求失败')
      } finally {
        this.loadingTable(false)
      }
    },
    // 处理搜索表单的值
    dealSearchFormParams() {
      const { pagination } = this.$refs.table
      const {pageSize, pageNum} = pagination
      return { ...this.searchParam, pageSize, pageNum }
    },
    // 新增
    addFinance() {
      this.$router.push({ name: 'ServerFinanceCreate' })
    },
    // 批量发布接口
    async batchUp(params) {
      try {
        const { msg, code } = await issueFinanceInfo(params)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 批量下架接口
    async batchLow(params) {
      try {
        const { msg, code } = await downFinanceInfo(params)
        this.initTableValue()
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 批量发布
    batchIssue() {
      const forbidden = ['1']
      const ids = this.$refs.table.selectedRowIds
      const check = ids.filter(item => forbidden.includes(item.status))
      if(check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的金融服务信息允许发布')
      }
      const id = ids.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定发布已选的金融服务信息'
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的金融服务信息')
      }
      this.beforeShowModal(true, {
        source: 'batchUp',
        params: id
      })
    },
    // 批量下架
    batchDown() {
      const forbidden = ['0']
      const ids = this.$refs.table.selectedRowIds
      const check = ids.filter(item => forbidden.includes(item.status))
      if(check.length !== 0) {
        return this.$apiStatusHandler(999, '只有已发布的金融服务信息允许下架')
      }
      const id = ids.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定下架已选的金融服务信息'
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的金融服务信息')
      }
      this.beforeShowModal(true, {
        source: 'batchLow',
        params: id
      })
    },
    // 检查订单的状态
    // 批量删除
    async batchDelete() {
      const forbidden = ['1']
      const ids = this.$refs.table.selectedRowIds
      const check = ids.filter(item => forbidden.includes(item.status))
      if(check.length !== 0) {
        return this.$apiStatusHandler(999, '只有待发布的金融服务信息允许删除')
      }
      const id = ids.map((item) => item.id)
      this.customModalOpt.contentTips = '是否确定删除已选的金融服务信息'
      if (id.length === 0) {
        return this.$apiStatusHandler(999, '您还未选中需要操作的金融服务信息')
      }
      const selectId = id.join(',')
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: selectId }
      })
    },
    async delete(row) {
      if(row.status === '1') {
        return this.$apiStatusHandler(999, '只有待发布的金融服务信息允许删除')
      }
      this.customModalOpt.contentTips = '是否确定删除该金融服务信息'
      this.beforeShowModal(true, {
        source: 'dealDeleteApi',
        params: { ids: row.id }
      })
    },
    // 调用删除接口
    async dealDeleteApi(params) {
      const { ids } = params
      try {
        const { msg, code } = await deleteFinanceInfo(ids)
        this.initTableValue(this.params)
        this.$apiStatusHandler(code, msg)
      } catch (error) {
        this.$apiStatusHandler(99, error.msg)
      }
    },
    // 编辑金融服务信息
    edit(row) {
      const { id, status } = row
      if(status === '1') {
        return this.$apiStatusHandler(999, '只有待发布的金融服务信息允许编辑')
      }
      this.$router.push({ name: 'ServerFinanceCreate', query: { type: 'edit', id } })
    },
    // 前往详情
    toDetail(row) {
      const { id } = row.scope
      this.$router.push({ name: 'ServerFinanceCreate', query: { type: 'detail', id } })
    }
  }
}
</script>
